module.exports = __webpack_public_path__ + "static/media/devices.71592317.svg";